/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Open Source Version is distributed with Sencha Ext JS pursuant to a FLOSS Exception agreed upon
 * between Sonatype, Inc. and Sencha Inc. Sencha Ext JS is licensed under GPL v3 and cannot be redistributed as part of a
 * closed source work.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

export default {
  LOGIN_TITLE: 'Welcome',
  LOGIN_SUBTITLE: 'Login to continue',
  SSO_BUTTON: 'Continue with SSO',
  SSO_BUTTON_CLOUD: 'Login',
  SSO_BUTTON_LOADING: 'Redirecting...',
  SSO_DIVIDER_LABEL: 'Or',
  USERNAME_LABEL: 'Username',
  PASSWORD_LABEL: 'Password',
  LOGIN_BUTTON: 'Log in',
  LOGIN_BUTTON_LOADING: 'Signing in...',
  CONTINUE_WITHOUT_LOGIN: 'Continue without login',
  INITIAL_PASSWORD_MESSAGE: 'To log in for the first time, use the generated admin password located at:',
  ERRORS: {
    WRONG_CREDENTIALS: 'Wrong username or password',
    CONNECTION_FAILED: 'Connection failed. Please check your network connection.',
    AUTHENTICATION_FAILED: 'An error occurred during authentication',
    USERNAME_REQUIRED: 'Username is required',
    PASSWORD_REQUIRED: 'Password is required'
  }
};
